// frontend/src/config.ts
export const API_URL = 'https://api.kostumakademi.com.tr';
export const FRONTEND_URL = 'https://www.kostumakademi.com.tr';
// Diğer konfigürasyon değerlerini de burada tanımlayabilirsiniz
export const APP_NAME = 'Costume Shop';
export const VERSION = '1.0.0';